/**
 * Created by Languagenut on 18/03/2020.
 */

import React from 'react'

export default class Success extends React.Component {

    constructor(props) {
        super();
        this.state = {
            gotTranslations: false,
            authenticated: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {

        return <div class="jumbotron text-center">
            <h1 class="display-4">Sorry</h1>
            <p class="lead">There has been a problem with your payment</p>
            <hr />
            <p>
                Having trouble? email <a href="mailto:home@languagenut.com">home@languagenut.com</a>
            </p>
            <p class="lead">
                <a class="btn btn-primary btn-sm" href="#/" role="button">Back to Payment</a>
            </p>
        </div>
    }
}
